import EditVariable from './EditVariable';

export default EditVariable;
